<template>
    <div>
        <b-table
            :items="historico"
            :fields="camposTabela"
            :per-page="itensPorPaginaSelected"
            :current-page="paginaAtual"
            responsive="sm"
            hover
            class="mb-2"
        >
            <template slot="data" slot-scope="data">
                {{ data.item.data | toDateTime }}
            </template>

            <template slot="anexos" slot-scope="data">
                <div v-if="data.item.anexos && data.item.anexos.length > 0" class="historico-anexos-container">
                    <b-button 
                        v-for="anexo in data.item.anexos" :key="anexo.propostaPrecoHistoricoAnexoId"
                        variant="light"
                        size="sm"
                        class="b-1 historico-anexo-btn"
                        title="Clique para fazer o download"
                        @click.stop.prevent="downloadAnexo(anexo)"
                    >
                        <i class="fa fa-paperclip mr-1"></i>
                        {{ anexo.nomeArquivo }}
                    </b-button>
                </div>
            </template>
        </b-table>
        <app-paginacao
            :totalItens="totalItens"
            :itensPorPagina="itensPorPaginaSelected"
            v-model="paginaAtual"
        >
            <template slot="paginacao">
                <b-form-select
                    v-model="itensPorPaginaSelected"
                    :options="itensPorPaginaOptions"
                ></b-form-select>
            </template>
        </app-paginacao>
    </div>
</template>
<script>
import PropostaPrecoServico from '../PropostaPrecoServico'
import PaginacaoComponent from '../../../shared/components/PaginacaoComponent'

export default {
    name: 'PropostaPrecoHistorico',
    components: {
        appPaginacao: PaginacaoComponent
    },
    props: {
        historico: {
            type: Array,
            required: false
        },
        propostaPrecoId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            paginaAtual: 1,
            itensPorPaginaSelected: 10,
            itensPorPaginaOptions: [
                { value: 5, text: 5 },
                { value: 10, text: 10 },
                { value: 25, text: 25 },
                { value: 50, text: 50 },
                { value: 100, text: 100 }
            ],
            camposTabela: [
                {
                    key: 'acoes',
                    label: '',
                    tdClass: 'text-center'
                },
                {
                    key: 'data',
                    label: 'Data',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'mensagem',
                    label: 'Mensagem',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'statusDescricao',
                    label: 'Status',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'responsavel',
                    label: 'Responsável',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'anexos',
                    label: 'Anexos',
                    filterable: true,
                    sortable: true,
                    tdClass: 'historico-anexos-cell'
                },
            ],
        }
    },
    computed: {
        totalItens() {
            return this.historico ? this.historico.length : 0
        }
    },
    methods: {
        downloadAnexo(anexo) {
            if (!this.propostaPrecoId || !anexo || !anexo.propostaPrecoHistoricoAnexoId) {
                this.$toast.error('Nao foi possivel identificar o anexo para download.', 'Erro', this.$toastConfig.error)
                return
            }

            this.$store.dispatch('addRequest')

            PropostaPrecoServico.DownloadHistoricoAnexo(this.propostaPrecoId, anexo.propostaPrecoHistoricoAnexoId)
                .then(response => {
                    if (response && response.data) {
                        if (response.data.type === 'application/json') {
                            this.$toast.error(
                                'Nao foi possivel fazer o download do anexo.',
                                'Erro',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(response.data, anexo.nomeArquivo)
                        }
                    } else {
                        this.$toast.error(
                            'Nao foi possivel fazer o download do anexo.',
                            'Erro',
                            this.$toastConfig.error
                        )
                    }
                })
                .catch(() => {
                    this.$toast.error(
                        'Nao foi possivel fazer o download do anexo.',
                        'Erro',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}

</script>

<style scoped>
.historico-anexos-cell {
    white-space: normal !important;
}

.historico-anexos-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
}

.historico-anexo-btn {
    max-width: 100%;
    white-space: normal !important;
    overflow-wrap: anywhere;
    word-break: break-word;
    text-align: left;
    line-height: 1.2;
}
</style>